import type { LibraryResponses } from "@tfg/types/endpoints/library"

import { getHomeRedirectUrlForUser } from "~/store/auth-context"
import { isSupplier } from "~/utils/permissions"

const BRAND_PROFILE_PATH = "/profile"
const SUPPLIER_PROFILE_PATH = "/supplier/profile"

/**
 * Map named post-auth destinations from the API to persona-specific routes.
 */
export const resolvePostAuthPath = ({
  destination,
  user,
  fallbackRedirectUrl,
}: {
  readonly destination: LibraryResponses.PostAuthDestination | undefined
  readonly user: LibraryResponses.TFGUser
  readonly fallbackRedirectUrl: string
}): string => {
  if (destination === undefined) {
    return fallbackRedirectUrl
  }

  const supplier = isSupplier(user)

  if (destination === "PROFILE") {
    return supplier ? SUPPLIER_PROFILE_PATH : BRAND_PROFILE_PATH
  }

  return getHomeRedirectUrlForUser(user)
}
